import React, { useState } from 'react';
import { copyText, userLocationLines, userPhotoCountLabel, userPhotoList } from '../../../adminApi';

function UserCard(props) {
  const user = props.user;
  const photos = userPhotoList(user);
  const [index, setIndex] = useState(0);
  const photo = photos[index];
  const selected = Boolean(props.selected);

  const stop = (event) => event.stopPropagation();

  const showPrev = (event) => {
    stop(event);
    setIndex((current) => (current === 0 ? photos.length - 1 : current - 1));
  };

  const showNext = (event) => {
    stop(event);
    setIndex((current) => (current === photos.length - 1 ? 0 : current + 1));
  };

  return (
    <div
      className={selected ? 'admin-card is-selected' : 'admin-card'}
      onClick={props.onSelect}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          props.onSelect();
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div className="admin-card__photo">
        {photo ? (
          <img src={photo.url} alt={user.name || 'Profile'} />
        ) : (
          <div className="admin-card__empty">No photo</div>
        )}
        {user.verifyImage && index === 0 ? (
          <span className="admin-card__badge">Verify</span>
        ) : null}
        {photos.length > 1 ? (
          <React.Fragment>
            <button type="button" className="admin-card__nav admin-card__nav--prev" onClick={showPrev} aria-label="Previous photo">
              ‹
            </button>
            <button type="button" className="admin-card__nav admin-card__nav--next" onClick={showNext} aria-label="Next photo">
              ›
            </button>
          </React.Fragment>
        ) : null}
      </div>
      <div className="admin-card__body">
        <strong>
          {user.name || 'Unknown'}{user.age != null ? ` | ${user.age}` : ''}
          {user.profileVerified ? ' ✓' : ''}
        </strong>
        <p className="admin-muted">
          {[user.gender, user.genderPreference].filter(Boolean).join(' → ') || 'No gender'}
        </p>
        {userLocationLines(user).map((line) => (
          <p key={line} className="admin-muted">{line}</p>
        ))}
        <p className="admin-muted">{userPhotoCountLabel(user)}</p>
        {props.reason ? <p className="admin-muted">Report: {props.reason}</p> : null}
        <div className="admin-actions">
          {props.onPreview ? (
            <button
              type="button"
              className="admin-btn"
              onClick={(event) => {
                stop(event);
                props.onPreview(user);
              }}
            >
              Preview
            </button>
          ) : null}
          <button
            type="button"
            className="admin-btn"
            onClick={(event) => {
              stop(event);
              copyText(user.userId);
            }}
          >
            UserID
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserCard;
